{
	"communities": [
		{
			"name": "Utrecht",
			"lat": 52.09073739999999,
			"lon": 5.081420100000023,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Netherlands"
		},
		{
			"name": "Nottingham",
			"lat": 52.9548,
			"lon": -1.1581,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Edinburgh",
			"lat": 55.9533,
			"lon": -3.1883,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Manchester",
			"lat": 53.4808,
			"lon": -2.2426,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Copenhagen",
			"lat": 55.6761,
			"lon": 12.5683,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "London",
			"lat": 51.5073509,
			"lon": -0.12775829999998223,
			"link": "https://pauseai.uk/london/",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Rosario",
			"lat": -32.9442,
			"lon": -60.6505,
			"link": "$$DISCORD_US$$"
		},
		{
			"name": "Paris",
			"lat": 48.8647,
			"lon": 2.349,
			"link": "$$DISCORD_FRANCE$$",
			"parent_name": "France"
		},
		{
			"name": "Montreal",
			"lat": 45.5088,
			"lon": -73.5616,
			"link": "https://pauseai.ca/montreal.html",
			"parent_name": "Canada"
		},
		{
			"name": "Nairobi",
			"lat": -1.286389,
			"lon": 36.817223,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Kenya"
		},
		{
			"name": "Stockholm",
			"lat": 59.3293,
			"lon": 18.0686,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Sweden"
		},
		{
			"name": "Marseille",
			"lat": 43.2963,
			"lon": 5.37,
			"link": "$$DISCORD_FRANCE$$",
			"parent_name": "France"
		},
		{
			"name": "São Paulo",
			"lat": -23.5338,
			"lon": -46.6253,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Fredrikstad",
			"lat": 59.2201,
			"lon": 10.9299,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Lucerne",
			"lat": 47.0502,
			"lon": 8.3093,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Berlin",
			"lat": 52.52,
			"lon": 13.405,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Rome",
			"lat": 41.8967,
			"lon": 12.482,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Italy"
		},
		{
			"name": "Toronto",
			"lat": 43.6511,
			"lon": -79.347,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Canada"
		},
		{
			"name": "Amsterdam",
			"lat": 52.378,
			"lon": 4.8971,
			"link": "https://chat.whatsapp.com/EOGvhoPCiCqDqwuf9JUxtB",
			"parent_name": "Netherlands"
		},
		{
			"name": "München",
			"lat": 48.137,
			"lon": 11.576,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Cambridge",
			"lat": 52.2053,
			"lon": 0.1192,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Hanoi",
			"lat": 21.0285,
			"lon": 105.8048,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Gdynia",
			"lat": 54.5168,
			"lon": 18.5419,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Poland"
		},
		{
			"name": "Blackpool",
			"lat": 53.8159,
			"lon": -3.0553,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Vancouver",
			"lat": 49.2463,
			"lon": -123.1162,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Canada"
		},
		{
			"name": "Melbourne",
			"lat": -37.8136,
			"lon": 144.9631,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Australia"
		},
		{
			"name": "Zurich",
			"lat": 47.3769,
			"lon": 8.5417,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Milan",
			"lat": 45.4642,
			"lon": 9.19,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Italy"
		},
		{
			"name": "Kraków",
			"lat": 50.0647,
			"lon": 19.945,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Poland"
		},
		{
			"name": "Yaoundé",
			"lat": 3.848,
			"lon": 11.5027,
			"link": "https://chat.whatsapp.com/EmSo5C486JzDdFOiojByje"
		},
		{
			"name": "Mo i Rana",
			"lat": 66.3149,
			"lon": 14.1657,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Trondheim",
			"lat": 63.4305,
			"lon": 10.3951,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Honefoss",
			"lat": 60.1002,
			"lon": 10.0202,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Kristiansand",
			"lat": 58.1556,
			"lon": 8.0167,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Prague",
			"lat": 50.0755,
			"lon": 14.4378,
			"link": "https://discord.gg/4rZ2nGZB3r",
			"parent_name": "Czechia"
		},
		{
			"name": "Santiago",
			"lat": -33.4569,
			"lon": -70.6483,
			"link": "https://t.me/+VwLcz7MAIDg3MTFh"
		},
		{
			"name": "Vienna",
			"lat": 48.2082,
			"lon": 16.3738,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Halle (Saale)",
			"lat": 51.482,
			"lon": 11.97,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Freiburg",
			"lat": 47.999,
			"lon": 7.842,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Würzburg",
			"lat": 49.794,
			"lon": 9.929,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Bonn",
			"lat": 50.735,
			"lon": 7.1,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Leipzig",
			"lat": 51.34,
			"lon": 12.375,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Nürnberg",
			"lat": 49.4543,
			"lon": 11.0746,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Canberra",
			"lat": -35.2809,
			"lon": 149.13,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Australia"
		},
		{
			"name": "PauseAI en Español",
			"lat": 40.4168,
			"lon": -3.7038,
			"link": "https://chat.whatsapp.com/KEgD22LEo6xEVvjH4fD8br"
		},
		{
			"name": "Launceston",
			"lat": -41.433349,
			"lon": 147.123323,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "Australia"
		},
		{
			"name": "Manila",
			"lat": 14.6,
			"lon": 120.98,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Helsinki",
			"lat": 60.17,
			"lon": 24.95,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Osaka",
			"lat": 34.69,
			"lon": 135.5,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Brussels",
			"lat": 50.85,
			"lon": 4.35,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Réunion Island",
			"lat": -21.115,
			"lon": 55.533,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "France"
		},
		{
			"name": "Veszprém",
			"lat": 47.1,
			"lon": 17.91,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Phoenix",
			"lat": 33.4484,
			"lon": -112.074,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Las Positas College (Livermore)",
			"lat": 37.6185,
			"lon": -121.7639,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "San Diego",
			"lat": 32.7157,
			"lon": -117.1611,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "San Francisco",
			"lat": 37.7749,
			"lon": -122.4194,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "UC Santa Barbara",
			"lat": 34.414,
			"lon": -119.8489,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Stanford",
			"lat": 37.4275,
			"lon": -122.1697,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "UC Boulder",
			"lat": 40.0076,
			"lon": -105.2659,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Denver",
			"lat": 39.7392,
			"lon": -104.9903,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Hartford",
			"lat": 41.7658,
			"lon": -72.6734,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Washington DC",
			"lat": 38.9072,
			"lon": -77.0369,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Orlando",
			"lat": 28.5383,
			"lon": -81.3792,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Atlanta",
			"lat": 33.749,
			"lon": -84.388,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Boise",
			"lat": 43.615,
			"lon": -116.2023,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Lawrence",
			"lat": 38.9717,
			"lon": -95.2353,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Boston",
			"lat": 42.3601,
			"lon": -71.0589,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Queen Anne's County",
			"lat": 39.0379,
			"lon": -75.9577,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Grand Rapids",
			"lat": 42.9634,
			"lon": -85.6681,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Washington University (Saint Louis)",
			"lat": 38.6488,
			"lon": -90.3108,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Jersey City",
			"lat": 40.7178,
			"lon": -74.0431,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Reno",
			"lat": 39.5296,
			"lon": -119.8138,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "New York City",
			"lat": 40.7128,
			"lon": -74.006,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Columbus",
			"lat": 39.9612,
			"lon": -82.9988,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Dayton",
			"lat": 39.7589,
			"lon": -84.1916,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Portland",
			"lat": 45.5051,
			"lon": -122.675,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Philadelphia",
			"lat": 39.9526,
			"lon": -75.1652,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Pittsburgh",
			"lat": 40.4406,
			"lon": -79.9959,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Providence",
			"lat": 41.824,
			"lon": -71.4128,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Vanderbilt University (Nashville)",
			"lat": 36.1447,
			"lon": -86.8027,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Austin",
			"lat": 30.2672,
			"lon": -97.7431,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Houston",
			"lat": 29.7604,
			"lon": -95.3698,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Seattle",
			"lat": 47.6062,
			"lon": -122.3321,
			"link": "$$WEBSITE_US$$",
			"parent_name": "United States"
		},
		{
			"name": "Leicester",
			"lat": 52.6369,
			"lon": -1.1398,
			"link": "https://pauseai.uk/leicester/",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Hyderabad",
			"lat": 17.385,
			"lon": 78.4867,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Fukuoka",
			"lat": 33.5904,
			"lon": 130.4017,
			"link": "https://line.me/ti/g2/rrV7AC9zmKz802Yk-BvJcyb7fHdppCtDQ1RGxQ?utm_source=invitation&utm_medium=link_copy&utm_campaign=default"
		},
		{
			"name": "Astana",
			"lat": 51.1694,
			"lon": 71.4491,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Geneva",
			"lat": 46.2044,
			"lon": 6.1432,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Exeter",
			"lat": 50.7184,
			"lon": -3.5339,
			"link": "$$DISCORD_GLOBAL$$",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Oxford",
			"lat": 51.752,
			"lon": -1.2577,
			"link": "https://pauseai.uk/oxford/",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Glasgow",
			"lat": 55.8642,
			"lon": -4.2518,
			"link": "https://pauseai.uk/glasgow/",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Porto",
			"lat": 41.1579,
			"lon": -8.6291,
			"link": "mailto:vpinto970@proton.me"
		},
		{
			"name": "Galesburg",
			"lat": 40.9478,
			"lon": -90.3712,
			"link": "mailto:hartwagle@gmail.com",
			"parent_name": "United States"
		},
		{
			"name": "Dhaka",
			"lat": 23.8103,
			"lon": 90.4125,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Potchefstroom",
			"lat": -26.7167,
			"lon": 27.1,
			"link": "$$DISCORD_GLOBAL$$"
		},
		{
			"name": "Brno",
			"link": "https://pauseai.cz",
			"lat": 49.19522,
			"lon": 16.60796
		},
		{
			"link": "https://www.pause-ai.de/lokalgruppen",
			"name": "Münster",
			"lat": 51.96,
			"lon": 7.62
		},
		{
			"name": "Olomouc",
			"link": "https://chat.whatsapp.com/D8j1ci4PDonJJ8Rk15wKnb",
			"lat": 49.5925739,
			"lon": 17.2496039
		}
	]
}
